import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  user: null,
  role: '',
  googleResponse: null,
  isGoogleSignIn: false,
  isTokenValid: false,
  setPassKey: '',
  isLoggedIn: false,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const loginUser = createAsyncThunk(
  'users/login',
  async (udata, thunkAPI) => {
    try {
      // let res = await axios.post('http://localhost:3000/auth/login', form_data, 
      //   { headers: form_data.getHeaders() });
      const response = await axios.post('/api/auth/login', udata);

      let data = response.data;

      if (response.status === 200) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      // console.log('Error', e.response.data);
      // thunkAPI.rejectWithValue(e.response.data);
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateAuth: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
      state.setPassKey = '';
    },
    logoutAuth: (state, { payload }) => {
      state.user = {};
      state.role = '';
      state.googleResponse = null;
      state.isLoggedIn = false;
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
      state.isGoogleSignIn = false;
      state.setPassKey = '';
    },
    googleSignIn: (state, { payload }) => {
      state.googleResponse = payload;
      state.isFetching = false;
      state.isGoogleSignIn = true;
    },
    googleSignInError: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.isGoogleSignIn = false;
      state.errorMessage = 'Invalid Credentials';
    },
    checkUserTokenVar: (state, { payload }) => {
      state.isTokenValid = true;
      state.errorMessage = '';
    },
    clearCheckUserTokenVar: (state, { payload }) => {
      state.isTokenValid = false;
      state.isFetching = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.isLoggedIn = true;
      state.user = payload.data;
      state.role = payload.data.userType;
      // state.role = localStorage.getItem('usertype');
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
        state.setPassKey = payload.data.setPassKey;
      }
      else {
        state.errorMessage = 'Internal error';
      }

      // state.errorMessage = payload.error;
    }
  },

  // extraReducers: (builder) => {
  //   builder
  //     .addCase(loginUser.pending, (state) => {
  //       state.isFetching = true;
  //     })
  //     .addCase(loginUser.rejected, (state, action) => {
  //         console.log('payload', action.payload);
  //         state.isFetching = false;
  //         state.isError = true;
  //         state.errorMessage = action.payload.message;
  //     })
  //     .addCase(loginUser.fulfilled, (state, action) => {
  //       console.log(action)
  //         state.user = action.payload;
  //         state.isFetching = false;
  //         state.isSuccess = true;
  //         return state;
  //     });
  // },
});

export const { clearStateAuth, logoutAuth, googleSignIn, googleSignInError, checkUserTokenVar, clearCheckUserTokenVar } = authSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAuth());
  }
}

export function clearUserTokenVar() {

  return async (dispatch) => {
    dispatch(clearCheckUserTokenVar());
  }
}


// export function logout() {

//   return async (dispatch) => {
//     dispatch(logoutAuth());
//   }
// }

// export function logout() {

//   return async (dispatch) => {
//     dispatch(logoutAuth());
//   }
// }

export const logout = () => async (dispatch, getState) => {
  try {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    // let tokenStr = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI1c19FcktEUFh3S3JadmhlZG9wRlpUcVJWeVFUaHdBeE5uWFUweEpFcnV3In0.eyJleHAiOjE2MzgzNzc2NzIsImlhdCI6MTYzODMzNDQ3MiwianRpIjoiMTMyZDg5MjQtYTY5YS00OWE0LWE0YmYtNTYwNzBmMzMyMGEzIiwiaXNzIjoiaHR0cDovL2xvY2FsaG9zdDo4MDgwL2F1dGgvcmVhbG1zL215cmVhbG0iLCJzdWIiOiIwODMwMDM5NC1lMzYyLTRiYzMtYTI5Yy05MzZmMDE2OWEyMzciLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJteWNsaWVudCIsInNlc3Npb25fc3RhdGUiOiIwMDkzMzU4Ni1lNmUzLTRjZmQtYTM0My1jNDM5NTQ3YmQwMTkiLCJhY3IiOiIxIiwiYWxsb3dlZC1vcmlnaW5zIjpbImh0dHBzOi8vd3d3LmtleWNsb2FrLm9yZyJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsiZGVmYXVsdC1yb2xlcy1teXJlYWxtIiwiSGVhZCBDbGVyayIsIm9mZmxpbmVfYWNjZXNzIiwidW1hX2F1dGhvcml6YXRpb24iXX0sInNjb3BlIjoiZW1haWwgcHJvZmlsZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6Im5ldyBjaGVjayBub3cgdXNlciIsInByZWZlcnJlZF91c2VybmFtZSI6InVzZXJvbmUiLCJnaXZlbl9uYW1lIjoibmV3IGNoZWNrIG5vdyIsImZhbWlseV9uYW1lIjoidXNlciIsImVtYWlsIjoidXNlcm9uZUBhc2QuY29tIn0.uBpjOG6nTWVTnXWCFvuhRgLYfAdprb6fP96Gj4wH_5FWzrKMYbVvPfGKtk7jnzVddSDrdLlKHu_gphtKof4eeXGZ-uOKvKLL-qmAMcRGnPO42bFzEspFesozCf3JD4QMxuVBZyDArsHykdUqzMaF_OBa6uxFW65iydAz7xtX3yPuulYPSWpWAD9n5pi-htIAhCVblJJnz1nAOmNZcRQGnZYb3Wz7lWdGxrKd9-i35yonCPwED3UBKkdt4OLp-vKb7MO_wsNsaaUaLQ2zESt64m8-zk9fXdDVppM-lP02rF3-R_Xt0w8D5HdfvziatBu4oPMcF_1T3G0sy611sgEaeg";
    const response = await axios.post('/api/auth/logout', tokenStr, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    // console.log('logoutdata', data)
    dispatch(logoutAuth());
    return data;
  } catch (error) {
    // console.log('error', error)
    if (error.response.data.message === "unauthorized") {
      dispatch(logoutAuth());
    }
    return error.response.data;
  }
};

export const checkUserToken = () => async (dispatch, getState) => {

  try {

    const { auth } = getState()
    let tokenStr = auth.user.token;
    // let tokenStr = 'auth.user.token';
    const response = await axios.get('/api/auth/checkTokenValidity', { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    // console.log('checkToken => ', data)
    dispatch(checkUserTokenVar(data));
    return data;
  } catch (error) {

    if (error.response.data.message === "unauthorized") {
      dispatch(logoutAuth());
    }
    return error.response.data;
  }

};

export function googleSignInAsyn(obj) {

  return async (dispatch) => {
    dispatch(googleSignIn(obj));
  }
}

export function googleSignInErrorAsyn(obj) {

  return async (dispatch) => {
    dispatch(googleSignInError(obj));
  }
}



// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of

export const authSelector = (state) => state.auth;


export default authSlice.reducer;
